var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.38574 0.499756L0.858398 3.34066V4.22311H11.9122V3.34066L6.38574 0.499756ZM6.38574 1.98629C6.78879 1.98629 7.11556 2.31306 7.11556 2.71611C7.11556 3.11917 6.78879 3.44628 6.38574 3.44628C5.98269 3.44628 5.65592 3.11928 5.65592 2.71611C5.65592 2.31294 5.9826 1.98629 6.38574 1.98629Z",
    fill: "#18A0FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.89648 4.60815V11.0449H10.8755V4.60815H9.90832V10.1891H9.41591L9.41579 4.60815H3.35636V10.1891H2.8636L2.86371 4.60815H1.89648ZM6.38602 5.35119C6.99804 5.35119 7.49392 5.84495 7.49392 6.4546C7.49392 7.06427 6.99804 7.55777 6.38602 7.55777C5.774 7.55777 5.27811 7.06435 5.27811 6.4546C5.27811 5.84561 5.77411 5.35119 6.38602 5.35119ZM6.42991 8.18324C6.74057 8.19097 7.04452 8.2828 7.31317 8.451C7.88744 8.80924 8.24098 9.47244 8.24098 10.189H4.53095C4.53095 9.47244 4.88461 8.80936 5.4581 8.451C5.75353 8.26633 6.08993 8.17372 6.42991 8.18324Z",
    fill: "#18A0FB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.857422 11.4294H11.9124V12.5002H0.857422V11.4294Z",
    fill: "#18A0FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.cdf298fd1c7c0791b8b1c3a18903032d.svg";
export { ForwardRef as ReactComponent };